import type { AvgsForm } from './extractAvgs'

const isBlank = (v: string | undefined) => !v || v.trim() === ''

export function avgsLooksPlausible(form: AvgsForm): boolean {
  const avgsNummer = form['Teilnehmer']?.['AVGS-Nummer (laufende Nummer)']
  const kundennummer = form['Teilnehmer']?.['Kundennummer']
  const gueltigkeitBeginn = form['Maßnahme']?.['Gültigkeit Beginn']

  return !(isBlank(avgsNummer) && isBlank(kundennummer) && isBlank(gueltigkeitBeginn))
}
